import { render, staticRenderFns } from "./UserNameUpdateModal.vue?vue&type=template&id=4c2306f6&scoped=true"
import script from "./UserNameUpdateModal.vue?vue&type=script&lang=js"
export * from "./UserNameUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./UserNameUpdateModal.vue?vue&type=style&index=0&id=4c2306f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2306f6",
  null
  
)

export default component.exports